import { FISH_TYPES, FISH_MARKET, FISH_RECIPES, FISH_RESERVATIONS, FISH_RESERVATIONS_LOG, FISH_ADDED } from '../constants'
const INITIAL_STATE = { fishTypes: null, fishMarket: null, fishRecipes: null, fishReservations: null, fishReservationsLog: null, addedFish: null }

export default ( state = INITIAL_STATE, action ) => {
  switch( action.type ) {
    case FISH_TYPES:
      return { ...state, fishTypes: action.payload }
    case FISH_MARKET:
      return { ...state, fishMarket: action.payload }
    case FISH_RECIPES:
      return { ...state, fishRecipes: action.payload }
    case FISH_RESERVATIONS:
      return { ...state, fishReservations: action.payload }
    case FISH_RESERVATIONS_LOG:
      return { ...state, fishReservationsLog: action.payload }
    case FISH_ADDED:
      return { ...state, addedFish: action.payload }
    default: 
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/fishReducer.js